<template>
  <v-dialog
    :value="value"
    persistent
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    @input="atualizarDialog"
  >
    <v-card>
      <v-toolbar color="primary" dark>
        <v-toolbar-title>Editar Pregão</v-toolbar-title>
        <v-spacer />
        <v-toolbar-items>
          <v-btn class="mx-2" icon>
            <v-icon dark large @click="solicitarFechamento">cancel</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <cadastroPregao
          ref="cadastroPregao"
          v-if="value"
          :key="`editar-${pregaoId || 'novo'}`"
          :modoEdicao="true"
          :pregaoId="pregaoId"
          :orgaosCadastrados="orgaosCadastrados"
          :produtosCadastrados="produtosCadastrados"
          @fechar="fecharModal"
        />
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn text @click="solicitarFechamento">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import cadastroPregao from "./cadastroPregao";
import { urlApi, showError } from "@/global";

export default {
  name: "modalEditarPregao",
  components: { cadastroPregao },
  props: {
    value: { type: Boolean, default: false },
    pregaoId: { type: [Number, String], default: null },
  },
  data() {
    return {
      orgaosCadastrados: [],
      produtosCadastrados: [],
    };
  },
  watch: {
    value(val) {
      if (val) {
        this.carregarOpcoes();
      }
    },
  },
  methods: {
    atualizarDialog(val) {
      this.$emit("input", val);
    },

    solicitarFechamento() {
      const cadastroPregao = this.$refs.cadastroPregao;

      if (cadastroPregao && typeof cadastroPregao.solicitarFechamento === "function") {
        cadastroPregao.solicitarFechamento();
        return;
      }

      this.fecharModal();
    },

    fecharModal() {
      this.$emit("input", false);
    },

    carregarOpcoes() {
      this.getOrgao();
      this.getProduto();
    },

    getOrgao() {
      axios
        .get(`${urlApi}/orgao`)
        .then((res) => {
          this.orgaosCadastrados = res.data.map((orgao) => orgao.nomeOrgao);
        })
        .catch(showError);
    },

    getProduto() {
      axios
        .get(`${urlApi}/produto`)
        .then((res) => {
          this.produtosCadastrados = res.data;
        })
        .catch(showError);
    },
  },
};
</script>
